@if (location(); as location) {
  <div class="location-detail">
    <div class="location-detail__header">
      <button mat-button [matMenuTriggerFor]="menu" class="location-detail__dropdown-trigger margin--left-l">
        Version: {{ version }}
        <mat-icon>arrow_drop_down</mat-icon>
      </button>

      <mat-menu #menu="matMenu" class="location-detail__version-menu">
        <button mat-menu-item (click)="version = 'v1'; getLocationDetails(locationId)">v1</button>
        <button mat-menu-item (click)="version = 'v3'; getLocationDetails(locationId)">v3</button>
        <button mat-menu-item (click)="version = 'v4'; getLocationDetails(locationId)">v4</button>
      </mat-menu>

      <button type="button" class="btn-icon" mat-dialog-close>
        <mat-icon>close</mat-icon>
      </button>
      <div class="location-detail__header--ok-logo">
        <img src="assets/ok-logo.svg" alt="OK a.m.b.a" />
      </div>
      <div class="location-detail__header--headers">
        <div class="small-text">
          {{ location.name }}
        </div>
        <div class="tiny-text">
          {{ location.formattedAddress }}
        </div>
        @if (showRestrictedInfo) {
          <div>
            <ok-feedback-info>
              Der vises information om adgangsbegræsning på nedenstående ladepunkter ud fra denne værdi:
              {{ customerNumbers.join(', ') }}
            </ok-feedback-info>
          </div>
        }
      </div>
    </div>
    <hr />
    <div class="location-detail__connectors">
      @for (chargingStation of chargingStations(); track chargingStation.chargingStationId) {
        <div>
          @for (connector of chargingStation.connectors; track connector.connectorId) {
            <div>
              <div class="location-detail__connector">
                <div class="location-detail__station-number">
                  Ladepunkt {{ connector.stationNumber }} 
                  <span class="location-detail__station-id">({{ chargingStation.chargingStationId }})</span>
                  @if (showRestrictedInfo) {
                    <span
                      class="location-detail__restricted-info"
                      [class.text-danger]="showRestrictedInfo && connector.isRestricted"
                      [class.text-success]="showRestrictedInfo && !connector.isRestricted">
                      @if (connector.isRestricted) {
                        Adgangsbegrænsning i spil
                      } @else {
                        Ingen adgangsbegrænsning i spil
                      }
                    </span>
                  }
                </div>
                @if (connector.firestoreConnectorInfo | async; as firestoreConnectorInfo) {
                  <div class="location-detail__connector-cols">
                    <div class="location-detail__price">
                      {{ connector.connectorPrice.pricePerkWh | number: '1.2-2' }}
                      {{ connector.connectorPrice.currency }}/kWh
                    </div>

                    <div
                      class="location-detail__status"
                      [class.connector-status-grey]="firestoreConnectorInfo.connectorStatus === connectorStatusEnum.Unknown"
                      [class.connector-status-green]="firestoreConnectorInfo.connectorStatus === connectorStatusEnum.Available"
                      [class.connector-status-yellow]="firestoreConnectorInfo.connectorStatus === connectorStatusEnum.Unavailable"
                      [class.connector-status-blue]="firestoreConnectorInfo.connectorStatus === connectorStatusEnum.Charging"
                      [class.connector-status-red]="firestoreConnectorInfo.connectorStatus === connectorStatusEnum.Faulted">
                      <mat-icon>power</mat-icon>
                      <span>
                        @switch (firestoreConnectorInfo.connectorStatus) {
                          @case (connectorStatusEnum.Unknown) {
                            Ukendt status
                          }
                          @case (connectorStatusEnum.Available) {
                            Tilgængelig
                          }
                          @case (connectorStatusEnum.Unavailable) {
                            Ikke tilgængelig
                          }
                          @case (connectorStatusEnum.Charging) {
                            I brug
                          }
                          @case (connectorStatusEnum.Faulted) {
                            Ude af drift
                          }
                        }
                      </span>
                    </div>
                    <div class="location-detail__info">
                      <span class="location-detail__info-icon">
                        @if (connector.power < 23) {
                          <mat-icon svgIcon="socket_type2"></mat-icon>
                        }
                        @if (connector.power >= 23) {
                          <mat-icon svgIcon="socket_type_ccs2"></mat-icon>
                        }
                        @if (connector.power > 75) {
                          <span class="location-detail__info-speed">
                            <mat-icon>keyboard_double_arrow_right</mat-icon>
                          </span>
                        }
                        @if (connector.power >= 23 && connector.power <= 75) {
                          <span class="location-detail__info-speed">
                            <mat-icon>keyboard_arrow_right</mat-icon>
                          </span>
                        }
                      </span>
                      <span class="location-detail__info-text">{{ connector.power }} kWh</span>
                    </div>
                  </div>
                }
                @if (connector.accessGroupIdentifier && connector.accessGroupName) {
                  <div class="access-group-info">
                    <ok-feedback-info>
                      <div>
                        <!-- <div class="icon-with-text"> -->
                          <strong>
                            Rabat via adgangsgruppen
                            <a
                              [routerLink]="['/access-groups']"
                              [queryParams]="{
                                accessGroupIdentifier: connector.accessGroupIdentifier,
                                filterName: connector.accessGroupName,
                              }"
                              target="_new"
                              title="Se detaljer">
                              {{ connector.accessGroupName }}
                            </a>
                          </strong>
                        <!-- </div> -->
                      </div>
                    </ok-feedback-info>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>
}

@if (location()) {
  <div class="ribbon" [matTooltip]="endpointUrl">{{ version }}</div>
}
